export default {
  color: '#7051dd',
  failedColor: '#F44336',
  thickness: '2px',
};
